// extracted by mini-css-extract-plugin
export default {"buttonContainer":"MainPage_buttonContainer__anejM"};